// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Skeletons-primaryButton-2EdwUw","skeletons":"Skeletons-skeletons-37aNjS","container":"Skeletons-container-1qCwML","skeleton":"Skeletons-skeleton-2dKWt4"};